/**
 * @version 1.0
 * @author xieyq
 * @createTime 2022/2/23
 * @updateTime 2022/2/23
 * @decription 被申请人相关的js处理
 * @namespace 【bsqr】 被申请人
 */
// 添加编辑被申请人
import appGuaranteeAddBsqr from '../../addGuarantee/addBSQR/index.vue';
import {typeRylx} from "@/filters";
import {Dialog} from "vant";
export default {
    // 依赖组件
    components: {appGuaranteeAddBsqr},
    // 数据
    data() {
        return {
            // 被申请人数据列表
            bsqrDataList: [],
            // 是否显示弹层
            showPopupBsqr: false,
            // 正在编辑的被申请人信息项
            bsqrEditItem: null,
            // 正在编辑的被申请人信息项索引
            bsqrEditIndex: -1,
            // 被申请人删除的id集合
            bsqrDelIds: [],
            // 被申请人加载完成
            bsqrLoaded: false,
            //被申请人标签
            bsqrLabel: '被申请人'
        };
    },
    // 计算属性
    computed: {
        // 被申请人id属性
        bsqrIdProp() {
            return this.fromSQBG ? 'cYdbDsrid' : 'cDbDsrid';
        },

        /**
         * 被申请人下拉选数据列表
         * @returns {Array<Object>}
         * */
        bsqrSelectDataList() {
            const _columnsBSQRS = [];
            this.bsqrDataList.forEach(dataItem => {
                _columnsBSQRS.push({
                    keyId: dataItem[this.bsqrIdProp],
                    text: dataItem.cDsrlx === '1' ? dataItem.cDsrxm : dataItem.cQymc
                });
            });
            return _columnsBSQRS;
        }
    },
    // 方法
    methods: {
        /**
         * 被申请人数据
         * @param {Array<Object>} data 申请人数据列表
         * @returns {void}
         * */
        initBsqrData(data) {
            // 申请人数据列表
            const _bsqrDataList = [];
            // 循环遍历数据处理数据
            data.forEach((item) => {
                // 被申请人类型文本
                item.cDsrlxText = typeRylx(item.cDsrlx);
                _bsqrDataList.push(item);
            });
            // 赋值申请人数据列表
            this.bsqrDataList = _bsqrDataList;
            // 申请人加载完成
            this.bsqrLoaded = true;
            // 上传材料同步被申请人数据
            this.scclSyncBsqrData();
        },

        /**
         * 添加、编辑被申请人
         * @param {Object} item 申请人信息项数据
         * @param {Number} index 索引
         * @returns {void}
         * */
        bsqrAddAEdit(item = null, index = -1){
            if (item) {
                this.bsqrEditItem = item;
                this.bsqrEditIndex = index;
            }
            // 生成被申请人表单
            this.showPopupBsqr = true;
        },

        /**
         * 删除被申请人
         * @param {String} bsqrid 被申请人id
         * @param {Number} index 当前被申请人索引
         * @returns {void}
         * */
        bsqrDelete(bsqrid, index) {
            Dialog.confirm({
                title: '提示',
                message: '删除被申请人后，对应的财产线索会一并删除，确认删除吗？',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 如果不是新增的则删除的id集合中存储对应的申请人id
                !this.bsqrDataList[index].isAdd && this.bsqrDelIds.push(bsqrid);
                // 删除对应的被申请人
                this.bsqrDataList.splice(index, 1);
                // 根据被申请人id删除对应的财产线索列表
                this.ccxsDeleteByBsqrId(bsqrid);
                // 根据人员id进行对应的身份证明材料的删除
                this.scclDelByRyId(bsqrid);
            }).catch(() => {

            });
        },

        /**
         * 取消添加、编辑被申请人
         * @returns {void}
         * */
        bsqrCancel() {
            // 编辑信息项置为null
            this.bsqrEditItem = null;
            // 索引置为-1
            this.bsqrEditIndex = -1;
            // 申请人弹层为false
            this.showPopupBsqr = false;
        },

        /**
         * 获取转化被申请人数据
         * @param {Object} formData 表单数据
         * @returns {Object} 转化之后的数据
         * */
        bsqrGetTransformData(formData) {
            const _transformData = {
                ...formData
            };
            return _transformData;
        },

        /**
         * 处理被申请人确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        bsqrHandlerConfirm(formData) {
            const _transformData = this.bsqrGetTransformData(formData);
            // 索引
            let _index = this.sqrDataList.length;
            // 如果编辑数据，则说明是编辑数据
            if (this.bsqrEditItem && this.bsqrEditIndex > -1) {
                // 进行数据替换
                this.bsqrDataList.splice(this.bsqrEditIndex, 1, _transformData);
                _index += this.bsqrEditIndex;
            } else {
                // 插入的索引
                _index += this.bsqrDataList.length;
                // 添加数据
                this.bsqrDataList.push(_transformData);
            }
            // 新增的时候需要对应的实际id赋值为cId
            _transformData.isAdd && (_transformData[this.bsqrIdProp] = _transformData.cId);
            // 更新对应的财产线索中的被申请人姓名
            this.ccxsUpdateCcsyrTextByBsqr(_transformData);
            // 同步人员名称
            this.scclSyncDataByRyId(_transformData[this.bsqrIdProp], this.bsqrGetScclName(_transformData), _index, 0);
        },

        /**
         * 获取被申请人名称
         * @param {Object} itemData 被申请人信息项数据
         * @returns {String} 申请人名称
         * */
        bsqrGetName(itemData) {
            // 如果是自然人，则取被申请人名称，否则取企业名称
            return itemData.cDsrlx == '1' ? itemData.cDsrxm : itemData.cQymc;
        },

        /**
         * 获取被申请人上传材料名称
         * @param {Object} itemData 被申请人信息项数据
         * @returns {String}
         * */
        bsqrGetScclName(itemData) {
            return `${this.bsqrLabel}-${this.bsqrGetName(itemData)}-${itemData.cDsrlxText}`
        },

        /**
         * 添加、编辑被申请人表单确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        bsqrConfirm(formData) {
            // 确认处理操作
            this.bsqrHandlerConfirm(formData);
            // 申请人取消为false
            this.bsqrCancel();
        },

        /**
         * 添加并继续
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        bsqrConfirmAContinue(formData) {
            // 确认处理操作
            this.bsqrHandlerConfirm(formData);
        }
    }
};
